import Api from '@services/api';

export default {
  withdraw(specialOfferId, origin) {
    return Api()
      .post(`/specialoffer/${specialOfferId}/withdraw`, null, {params: {origin}})
      .then((res) => res.data);
  },
  create(specialOffer) {
    return Api()
      .post(`/specialoffer`, specialOffer)
      .then((res) => res.data);
  },
  getAvailability(accommodationId) {
    return Api()
      .get(`/specialoffer/availability/${accommodationId}`)
      .then((res) => res.data);
  },
  updateTimes(specialOfferId, times) {
    return Api()
      .put(`/specialoffer/${specialOfferId}/times`, times)
      .then((res) => res.data);
  },
};
